import React, { useState, useEffect } from 'react'
import { BaseUrl } from "../../helper/BaseUrl";
import axios from "axios";
import { Link } from 'react-router-dom'

const truncateText = (htmlString, maxLength) => {
    if (!htmlString || typeof htmlString !== "string") return "";
    const plainText = htmlString.replace(/<\/?[^>]+(>|$)/g, "");
    return plainText.length > maxLength ? plainText.substring(0, maxLength) + "..." : plainText;
};

export default function BlogCard({initialData}) {
    const [allData, setAllData] = useState(initialData || []);
    const [visibleCount, setVisibleCount] = useState(4); // show 6 initially
    const [isLoadMore, setIsLoadMore] = useState(true);  

    useEffect(() => {
    const dataFetcher = async () => {
        try {
        const response = await axios.get(`${BaseUrl}/api/blog`);
        // console.log("API response:", response.data);
        setAllData(response.data?.data || []); 
        } catch (error) {
        console.error("Data fetch error:", error);
        }
    };

    dataFetcher();
    }, []);

    const handleLoadMore = () => {
        if (isLoadMore) {
        const newCount = Math.min(visibleCount + 3, allData.length);
        setVisibleCount(newCount);
        if (newCount >= allData.length) {
            setIsLoadMore(false);
        }
        } else {
        setVisibleCount(4); // show 6 initially
        setIsLoadMore(true);
        }
    };

    if (!allData) {
        return null;
    }

  return (
    <>
    <section className="blogpage">
        <div className="container">
            <div className="row">

                <div className="col-lg-12">
                    <h1 className="heading center-heading">Our Blogs</h1>

                    <div className="blogcard-row">
                        {allData.slice(0, visibleCount).map((data, index) => (
                        <div className="bloglist-box" key={index}>
                            <Link to={`/blog/${data.slug}`}>
                                <div>
                                    <img src={`${BaseUrl}${data.listing_image}`} loading="lazy" className="img-responsive" alt={data.alt}/>
                                </div>
                                <span>{truncateText(data.title, 90)}</span>
                                <p>{truncateText(data.shortdescription, 120)}</p>
                            </Link>
                        </div>
                        ))}
                    </div>
                    
                    {allData.length > 4 && (
                    <div className='text-center'>
                        <Link onClick={handleLoadMore} className="default-btn red-default">
                            {isLoadMore ? "View More" : "View Less"}
                        </Link>
                    </div>
                    )}
                </div> 

            </div>
        </div>
    </section>
    </>
  )
}
